"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationAffiliation = void 0;
/**
 * Defines an affiliation/assotiation/relationship between 2 distinct oganizations, that is not a part-of relationship/sub-division relationship.
 */
var OrganizationAffiliation = /** @class */ (function () {
    function OrganizationAffiliation() {
    }
    return OrganizationAffiliation;
}());
exports.OrganizationAffiliation = OrganizationAffiliation;
